export default {
  title: 'Países',
  importExport: 'Importar/Exportar',
  countriesConfig: 'Configuración de Países',
  close: 'Cerrar',
  save: 'Guardar',
  json: 'JSON',
  noData: 'Sin datos',
  headerName: 'Nombre',
  headerIsoCode: 'Código ISO',
  headerTrpCost: 'Costo TRP',
  headerWeeklyMinSpend: 'Inversión Mín. Semanal',
  validationJsonRequired: 'El JSON es requerido',
  validationInvalidJson: 'JSON inválido',
  validationInvalidCountries: 'Países inválidos'
}
